import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Row, Col } from 'reactstrap';
import '../../assets/css/CompanyCirclesStyle.css';
import {CIRCLE_COLORS} from '../../constants.js';


const getBackground = (skill, color, disabledColor) => {
  return skill === true ? color : (disabledColor ?? CIRCLE_COLORS.disabled);
}

const getActiveSkillsPct = (skills) => {
  const activeSkills = skills.reduce(
    (total, skill) => total + (skill === true ? 1 : 0)
  );
  return Math.round(activeSkills/skills.length * 100);
}

const getCompanyOrderCircleDataset = (skills) => {
  return {
    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1],
    backgroundColor: [
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      getBackground(skills?.sales, CIRCLE_COLORS.orderPrimary, CIRCLE_COLORS.orderSecondary),
      getBackground(skills?.administration, CIRCLE_COLORS.orderPrimary, CIRCLE_COLORS.orderSecondary),
      getBackground(skills?.operation, CIRCLE_COLORS.orderPrimary, CIRCLE_COLORS.orderSecondary),
    ],
    hoverBackgroundColor: [
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      getBackground(skills?.sales, CIRCLE_COLORS.orderHoverPrimary, CIRCLE_COLORS.hoverSecondary),
      getBackground(skills?.administration, CIRCLE_COLORS.orderHoverPrimary, CIRCLE_COLORS.hoverSecondary),
      getBackground(skills?.operation, CIRCLE_COLORS.orderHoverPrimary, CIRCLE_COLORS.hoverSecondary),
    ],
    borderColor: [
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
    ],
    borderWidth: 2,
    borderAlign: 'inner',
    weight: 3
  };
}

const getCompanyControlCircleDataset = (skills) => {
  return {
    label: 'Círculo de Control',
    data: [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0],
    backgroundColor: [
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      getBackground(skills?.human_capital, CIRCLE_COLORS.controlPrimary, CIRCLE_COLORS.controlSecondary),
      getBackground(skills?.productivity_indicators, CIRCLE_COLORS.controlPrimary, CIRCLE_COLORS.controlSecondary),
      getBackground(skills?.total_financial_information, CIRCLE_COLORS.controlPrimary, CIRCLE_COLORS.controlSecondary),
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
    ],
    hoverBackgroundColor: [
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      getBackground(skills?.human_capital, CIRCLE_COLORS.controlHoverSecondary, CIRCLE_COLORS.hoverSecondary),
      getBackground(skills?.productivity_indicators, CIRCLE_COLORS.controlHoverSecondary, CIRCLE_COLORS.hoverSecondary),
      getBackground(skills?.total_financial_information, CIRCLE_COLORS.controlHoverSecondary, CIRCLE_COLORS.hoverSecondary),
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
    ],
    borderColor: [
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
    ],
    borderWidth: 2,
    borderAlign: 'inner',
    weight: 2,
  };
}

const getCompanyQualityCircleDataset = (skills) => {
  return {
    label: 'Círculo de Calidad',
    data: [0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    backgroundColor: [
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      getBackground(skills?.quality_culture, CIRCLE_COLORS.qualityPrimary, CIRCLE_COLORS.qualitySecondary),
      getBackground(skills?.human_development_place, CIRCLE_COLORS.qualityPrimary, CIRCLE_COLORS.qualitySecondary),
      getBackground(skills?.development_strategies, CIRCLE_COLORS.qualityPrimary, CIRCLE_COLORS.qualitySecondary),
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
    ],
    hoverBackgroundColor: [
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      getBackground(skills?.quality_culture, CIRCLE_COLORS.qualityHoverPrimary, CIRCLE_COLORS.hoverSecondary),
      getBackground(skills?.human_development_place, CIRCLE_COLORS.qualityHoverPrimary, CIRCLE_COLORS.hoverSecondary),
      getBackground(skills?.development_strategies, CIRCLE_COLORS.qualityHoverPrimary, CIRCLE_COLORS.hoverSecondary),
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
    ],
    borderColor: [
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
    ],
    borderWidth: 2,
    borderAlign: 'inner',
    weight: 2
  };
}

const getCompanyLeadershipCircleDataset = (skills) => {
  return {
    label: 'Círculo de Liderazgo',
    data: [1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    backgroundColor: [
      getBackground(skills?.market_strategies, CIRCLE_COLORS.leadershipPrimary, CIRCLE_COLORS.leadershipSecondary),
      getBackground(skills?.leadership_culture, CIRCLE_COLORS.leadershipPrimary, CIRCLE_COLORS.leadershipSecondary),
      getBackground(skills?.long_term_strategies, CIRCLE_COLORS.leadershipPrimary, CIRCLE_COLORS.leadershipSecondary),
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
    ],
    hoverBackgroundColor: [
      getBackground(skills?.market_strategies, CIRCLE_COLORS.leadershipHoverPrimary, CIRCLE_COLORS.hoverSecondary),
      getBackground(skills?.leadership_culture, CIRCLE_COLORS.leadershipHoverPrimary, CIRCLE_COLORS.hoverSecondary),
      getBackground(skills?.long_term_strategies, CIRCLE_COLORS.leadershipHoverPrimary, CIRCLE_COLORS.hoverSecondary),
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
      CIRCLE_COLORS.disabled,
    ],
    borderColor: [
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
      CIRCLE_COLORS.border,
    ],
    borderWidth: 2,
    borderAlign: 'inner',
    weight: 2
  };
}

const CompanyCircles = (props) => {
  const { circleSkills } = props

  const chartData = {
    labels: [
      'Estrategias de Mercado',
      'Cultura de liderazgo',
      'Estrategias de negocio a largo plazo',
      'Cultura de Calidad',
      'Lugar de Desarrollo Humano',
      'Estrategias de Desarrollo',
      'Capital Humano Autodirigido',
      'Indicadores de Productividad',
      'Información Financiera Total',
      'Ventas',
      'Administración',
      'Operación',
    ],
    datasets: [
      getCompanyLeadershipCircleDataset(circleSkills),
      getCompanyQualityCircleDataset(circleSkills),
      getCompanyControlCircleDataset(circleSkills),
      getCompanyOrderCircleDataset(circleSkills),
    ],
  }

  const orderPct = getActiveSkillsPct([
    circleSkills.sales,
    circleSkills.administration,
    circleSkills.operation
  ]);
  const controlPct = getActiveSkillsPct([
    circleSkills.human_capital,
    circleSkills.productivity_indicators,
    circleSkills.total_financial_information
  ]);
  const qualityPct = getActiveSkillsPct([
    circleSkills.quality_culture,
    circleSkills.human_development_place,
    circleSkills.development_strategies
  ]);
  const leadershipPct = getActiveSkillsPct([
    circleSkills.market_strategies,
    circleSkills.leadership_culture,
    circleSkills.long_term_strategies
  ]);  

  return (
    <Row>
      <Col lg={4}>
        <Row className="circle-label-order">
          <Col xs={8} className="circle-label">Orden</Col>
          <Col xs={4} className="circle-label-pct">{orderPct}%</Col>
        </Row>
        <Row className="circle-label-control">
          <Col xs={8} className="circle-label">Control</Col>
          <Col xs={4} className="circle-label-pct">{controlPct}%</Col>
        </Row>
        <Row className="circle-label-quality">
          <Col xs={8} className="circle-label">Calidad</Col>
          <Col xs={4} className="circle-label-pct">{qualityPct}%</Col>
        </Row>
        <Row className="circle-label-leadership">
          <Col xs={8} className="circle-label">Liderazgo</Col>
          <Col xs={4} className="circle-label-pct">{leadershipPct}%</Col>
        </Row>
      </Col>
      <Col lg={8} className="col-circle">
        <div height="100px">
        <Pie
          data={chartData}
          options={{
            legend: {
              display: false
            },
            responsive: true,
            maintainAspectRatio: true,
            title: {
              display: false,
              text: ['GRADO DE CONFIABILIDAD Y', 'DESARROLLO DE LA EMPRESA'],
              position: 'top',
              fontFamily: 'Montserrat',
              fontColor: '#868E96'
            },
          }}
          className="col-circle" />
          </div>
      </Col>
    </Row>
  );
}

export default CompanyCircles;